import { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { isName, isPhone, isPwd, isRRNBack, isRRNFront } from "../../../utils/validate";


export default function SignUpPasswordFields({ onValidChange, onNext }) {
    const [pwd, setPwd] = useState("");
    const [pwdConfirm, setPwdConfirm] = useState("");
    const pwdValid = isPwd(pwd);
    const pwdConfirmValid = pwd === pwdConfirm && pwdValid;

    const formValid = pwdValid && pwdConfirmValid;

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formValid) return;

        onNext({ password: pwd });
    };
    useEffect(() => {
        onValidChange?.(formValid);        // prop 이 있으면 호출
    }, [formValid, onValidChange]);



    return (
        <form onSubmit={handleSubmit} className="flex flex-col h-full">
            <div className="py-9">
                <p className="text-2xl md:text-3xl  leading-tight">
                    비밀번호 설정
                </p>
                <p className="text-sm md:text-lg text-[#4A8AFF] mt-2">
                    로그인에 사용하실 비밀번호를 설정해 주세요.
                </p>
            </div>

            <div className="flex-1 overflow-y-auto space-y-6">
                {/* 이름 */}
                <div>
                    <label className="block text-sm md:text-lg font-medium mb-1">
                        비밀번호
                        {!pwdValid && pwd && (
                            <span className="ml-5 text-[#DE4F4F] text-xs md:text-sm">
                                영어, 숫자, 특수문자를 포함한 8자 이상 입력해주세요.
                            </span>
                        )}
                    </label>

                    <input
                        type="password"
                        value={pwd}
                        onChange={(e) => setPwd(e.target.value)}
                        placeholder="영숫·특수문자 포함 8자 이상"
                        className={clsx(
                            "w-full border rounded-lg px-3 py-3.5 bg-[#F1F1F1] outline-none text-sm md:text-lg",
                            !pwdValid && pwd && "border-[#DE4F4F]"
                        )}

                    />
                </div>

                <div>
                    <label className="block text-sm md:text-lg font-medium mb-1">
                        비밀번호 확인
                        {!pwdConfirmValid && pwdConfirm && (
                            <span className="ml-5 text-[#DE4F4F] text-xs md:text-sm">
                                비밀번호가 일치하지 않습니다.
                            </span>
                        )}
                    </label>

                    <input
                        type="password"
                        value={pwdConfirm}
                        onChange={(e) => setPwdConfirm(e.target.value)}
                        placeholder="영숫·특수문자 포함 8자 이상"
                        className={clsx(
                            "w-full border rounded-lg px-3 py-3.5 bg-[#F1F1F1] outline-none text-sm md:text-lg",
                            !pwdConfirmValid && pwdConfirm && "border-[#DE4F4F]"
                        )}
                    />
                </div>


            </div>
            <button
                type="submit"
                disabled={!formValid}
                className="mt-8 mb-6 w-full py-3 rounded-xl bg-[#5F9BFF] text-white
               disabled:bg-[#F1F1F1] disabled:text-gray-400">
                다음으로
            </button>
        </form>
    );
}
